import { Badge } from '@/components/common/Badge'
import { ButtonDefault } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { useLinkInternal } from '@/hooks/useLinkInternal'
import { useToggleFiltersPanel } from '@/hooks/useToggleFiltersPanel'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'

import styles from './FilterInputTagPopular.module.scss'

const MAX_VISIBLE = 4

type TagType = {
  count: number
  label: string
  slug: string
}

type Props = {
  tagSelected?: TagType
  tags: TagType[]
}

export const FilterInputTagPopular = ({ tags, tagSelected }: Props) => {
  const { buildRelative } = useLinkInternal()
  const isNavigating = useIsNavigating()
  const toggleFiltersPanel = useToggleFiltersPanel('tags')

  const tagsPopular = tags.slice(0, MAX_VISIBLE)
  const isSelectedVisible = tagsPopular.some((tag) => tag.slug === tagSelected?.slug)

  const tagsVisible =
    tagSelected && !isSelectedVisible ? [...tagsPopular.slice(0, MAX_VISIBLE - 1), tagSelected] : tagsPopular

  if (tagsVisible.length === 0) return <p className={styles.emptyMessage}>No Tags found.</p>

  return (
    <div className={styles.container}>
      <ul className={styles.tags}>
        {tagsVisible.map((tag, i) => {
          const isSelected = tagSelected?.slug === tag.slug

          return (
            <li key={i}>
              <ButtonDefault
                as='LinkRoute'
                colorScheme={isSelected ? 'selected' : undefined}
                fontNormal
                href={buildRelative({ tagSlug: !isSelected ? tag.slug : undefined })}
                showLoadingMask={isNavigating}
                variant='group'
              >
                <span className={styles.tag}>
                  <span>{tag.label}</span>
                  <span className={styles.count}>
                    <Badge count={tag.count} isCompact isSelected={isSelected} />
                  </span>
                </span>
              </ButtonDefault>
            </li>
          )
        })}
        <li>
          <ButtonDefault
            aria-label='More Tags...'
            fontNormal
            onClick={toggleFiltersPanel}
            showLoadingMask={isNavigating}
            title='More Tags...'
            variant='group'
            {...getClickawayIgnoreProps(['collapse-expanded'])}
          >
            <Icon name='ellipsis' />
          </ButtonDefault>
        </li>
      </ul>
    </div>
  )
}
